RemovePhoneController.$inject = ['$scope', '$uibModalInstance', 'CurrentUser',
  '$timeout'
]

export default function RemovePhoneController($scope, $uibModalInstance,
  CurrentUser, $timeout) {

  $scope.error = null;
  $scope.busy = false;
  $scope.password = '';


  $timeout(function () {
    document.querySelector('[name="password"]').focus();
  });

  $scope.removePhone = function () {
    if ($scope.busy) return;
    $scope.busy = true;
    CurrentUser.api.removePhone(null, {
      password: $scope.password
    }).then(function () {
      CurrentUser.api.get().then(function (data) {
        $uibModalInstance.close(data);
      });
    }, function (response) {
      $scope.busy = false;
      document.querySelector('[name="password"]').focus();
      $scope.error = response.data;
    });
  };
}



// WEBPACK FOOTER //
// ./project/modals/remove-phone/remove-phone.controller.js